import { render, staticRenderFns } from "./classes_view.vue?vue&type=template&id=30f0703b&"
import script from "./classes_view.vue?vue&type=script&lang=js&"
export * from "./classes_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports